import React from "react";
import { Zap, Flame, Gift, Target } from "lucide-react";
import { useTranslation } from "react-i18next";

// Compact 3-cell strip on the Dashboard: Energy · Streak · Daily Goal.
// Each cell is tappable (refill energy, restore streak, claim goal).
export default function StatStrip({ profile, goal, onEnergy, onStreak, onClaimGoal }) {
  const { t } = useTranslation();
  const goalDone = goal && goal.progress >= goal.target;
  const goalClaimable = goalDone && !goal.claimed;
  const cellBase =
    "rounded-2xl p-3 border flex flex-col items-center justify-center text-center min-h-[76px] active:scale-[0.97] transition-transform";
  return (
    <div className="grid grid-cols-3 gap-2">
      <button data-testid="card-energy" onClick={onEnergy} className={`${cellBase} bg-white border-[#E6E2D8]`}>
        <Zap size={16} strokeWidth={1.8} className="text-[#5F7161] mb-1" />
        <p style={{ fontFamily: "Outfit, sans-serif" }} className="text-lg font-semibold leading-none text-[#2C332A]">
          {profile.energy}/{profile.max_energy}
        </p>
        <p className="text-[10px] uppercase tracking-wide text-[#8AA48F] mt-1">{t("dashboard.energy_card_title")}</p>
      </button>

      <button data-testid="card-streak" onClick={onStreak} className={`${cellBase} bg-white border-[#E6E2D8]`}>
        <Flame size={16} strokeWidth={1.8} className="text-[#D0A98F] mb-1" />
        <p style={{ fontFamily: "Outfit, sans-serif" }} className="text-lg font-semibold leading-none text-[#2C332A]">
          {profile.current_streak}
        </p>
        <p className="text-[10px] uppercase tracking-wide text-[#8AA48F] mt-1">{t("dashboard.streak_card_title")}</p>
      </button>

      <button
        data-testid={goalClaimable ? "claim-daily-goal-btn" : "card-daily-goal"}
        onClick={goalClaimable ? onClaimGoal : undefined}
        className={`${cellBase} ${goalClaimable ? "bg-[#5F7161] border-[#5F7161] text-white animate-pulse" : "bg-white border-[#E6E2D8]"}`}
      >
        {goalClaimable
          ? <Gift size={16} strokeWidth={1.8} className="mb-1" />
          : <Target size={16} strokeWidth={1.8} className="text-[#5F7161] mb-1" />}
        <p style={{ fontFamily: "Outfit, sans-serif" }} className={`text-lg font-semibold leading-none ${goalClaimable ? "text-white" : "text-[#2C332A]"}`}>
          {goal ? `${goal.progress}/${goal.target}` : "–"}
        </p>
        <p className={`text-[10px] uppercase tracking-wide mt-1 ${goalClaimable ? "text-white/80" : "text-[#8AA48F]"}`}>
          {goalClaimable ? t("daily_goal.claim_short") : t("daily_goal.title")}
        </p>
      </button>
    </div>
  );
}
